import React from 'react'

interface NotificationBellIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const NotificationBellIcon: React.FC<NotificationBellIconProps> = ({
  color = '#888888',
  gradient,
  width = 24,
  height = 24,
  alt = 'Notification bell icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 14 14'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M6.407 14a2.19 2.19 0 01-2.187-2.188.438.438 0 01.875 0c0 .725.59 1.313 1.312 1.313.724 0 1.313-.588 1.313-1.313a.438.438 0 01.875 0A2.19 2.19 0 016.407 14z'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M11.22 12.25H1.595a1.022 1.022 0 01-.664-1.797.408.408 0 01.047-.035 3.92 3.92 0 001.346-2.957V5.833A4.088 4.088 0 016.408 1.75c.093 0 .194.002.287.018a.438.438 0 11-.143.862c-.047-.007-.098-.005-.144-.005a3.212 3.212 0 00-3.209 3.208v1.628c0 1.41-.618 2.743-1.693 3.658l-.026.02a.144.144 0 00-.03.09c0 .08.066.146.145.146h9.625c.08 0 .146-.066.146-.146a.14.14 0 00-.032-.09l-.025-.02A4.797 4.797 0 019.616 7.46v-.636a.438.438 0 01.875 0v.636c0 1.136.49 2.211 1.348 2.96a1.018 1.018 0 01.402.81c0 .561-.458 1.019-1.021 1.019z'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M10.49 5.833a2.92 2.92 0 01-2.916-2.916A2.92 2.92 0 0110.491 0a2.92 2.92 0 012.917 2.917 2.92 2.92 0 01-2.917 2.916zm0-4.958a2.044 2.044 0 00-2.04 2.042c0 1.126.915 2.041 2.04 2.041a2.044 2.044 0 002.043-2.041A2.044 2.044 0 0010.49.875z'
      ></path>
    </svg>
  )
}

export default NotificationBellIcon
